// extracted by mini-css-extract-plugin
export default {"mainWrapper":"styles_mainWrapper__XHWr4","backWrapper":"styles_backWrapper__naP+k","filler":"styles_filler__wYHHQ"};